import { Typography } from "@mui/material";
import { PrimaryInfoAlert } from "react-common-ui-library";
import { useIntl } from "react-intl";
import {
  FIND_PROVIDER_LINK,
  FIND_PROVIDER_URL,
  PROVIDER_CONTACT_NUMBER,
  TARGET_BLANK,
} from "../../../Constants/CommonConstants";
import {
  LINK_APPLICATION_PROVIDER_SEARCH_LINK,
  LINK_MY_APPLICATION_SEARCH_ALERT,
  NEED_HELP_TEXT,
  NEED_HELP_TEXT_TWO,
  SEARCH_HAP_ID_ALERT_TEXT,
} from "../../../Constants/LinkMyApplicationConstants";
import ConfigService from "../../../Services/ConfigService";
import EndpointService from "../../../Services/EndpointService";
import { StyledInlineLink } from "../../../Styles/Common/CommonStyles";

const providerContactNumber = ConfigService(PROVIDER_CONTACT_NUMBER);
const findProviderUrlLink = EndpointService(FIND_PROVIDER_URL);

/**
 * @description Alert component with static data, it uses PrimaryInfoAlert component from component library
 * @returns {ReactNode} Alert banner with Hap Id static info
 */
const SearchHAPIdAlert = () => {
  const intl = useIntl();

  return (
    <PrimaryInfoAlert
      id={LINK_MY_APPLICATION_SEARCH_ALERT}
      title={intl.formatMessage({ id: NEED_HELP_TEXT })}
      content={
        <Typography id={NEED_HELP_TEXT_TWO}>
          {intl.formatMessage(
            { id: SEARCH_HAP_ID_ALERT_TEXT },
            {
              providerSearchLink: (
                <StyledInlineLink
                  href={findProviderUrlLink}
                  target={TARGET_BLANK}
                  id={FIND_PROVIDER_LINK}
                  aria-label={`${intl.formatMessage({
                    id: LINK_APPLICATION_PROVIDER_SEARCH_LINK,
                  })}`}
                >
                  {intl.formatMessage({
                    id: LINK_APPLICATION_PROVIDER_SEARCH_LINK,
                  })}
                </StyledInlineLink>
              ),
              providerContactNumber: providerContactNumber,
            }
          )}
        </Typography>
      }
    />
  );
};

export default SearchHAPIdAlert;
